import { Product } from '../../../../models/product';

export type SortKey = '' | 'price' | 'height' | 'shelf';
export type SortDir = '' | 'v' | 'h';
export type SortType = '' | 'asc' | 'desc';

export const SORTING = [
    {value: ',', title: 'DONT_SORT'},
    {value: 'price,asc', title: 'RULES.SORT.PRICE_ASC'},
    {value: 'price,desc', title: 'RULES.SORT.PRICE_DESC'},
    {value: 'height,asc', title: 'RULES.SORT.SIZE_ASC'},
    {value: 'height,desc', title: 'RULES.SORT.SIZE_DESC'},
    {value: 'shelf,', title: 'RULES.SORT.GOLDEN_SHELF'}
];
export const DIRECTION = [
    {value: 'h', title: 'RULES.SORT.HORIZONTAL'},
    {value: 'v', title: 'RULES.SORT.VERTICAL'}
];


interface Sort {
    readonly key: SortKey;
    readonly dir: SortDir;
    readonly type: SortType;
    sort(a: Product, b: Product, placePredict?: any): number;
}

export class SortBase implements Sort {
    readonly key: SortKey;
    readonly dir: SortDir;
    readonly type: SortType;

    get value() {
        return `${this.key.toString()},${this.type.toString()}`;
    }

    get isVertical() {
        return this.dir == 'v';
    }

    get isHorizontal() {
        return this.dir == 'h';
    }

    constructor(key: SortKey, dir: SortDir, type: SortType) {
        this.key = key || '';
        this.dir = dir || 'h';
        this.type = type || '';
    }

    sort(a: Product, b: Product, placePredict?: any): number {
        return 0;
    }
}

export class SortByKey extends SortBase {
    constructor(key: SortKey, dir: SortDir, type: SortType) {
        super(key, dir, type);
    }

    sort(a: Product, b: Product): number {
        if (a[this.key] === b[this.key]) return 0;
        const reverse = this.type == 'desc' ? -1 : 1;
        return a[this.key] < b[this.key] ? reverse * -1 : reverse * 1;
    }
}

export class SortByPrice extends SortBase {
    constructor(key: SortKey, dir: SortDir, type: SortType) {
        super(key, dir, type);
    }

    sort(a: Product, b: Product): number {
        if (a.avgPrice === b.avgPrice) return 0;
        const reverse = this.type == 'desc' ? -1 : 1;
        return a.avgPrice < b.avgPrice ? reverse * -1 : reverse * 1;
    }
}

export class SortByShelf extends SortBase {
    get isVertical() {
        return true;
    }

    constructor(key: SortKey, dir: SortDir, type: SortType) {
        super(key, 'v', type);
    }

    sort(a: Product, b: Product, placePredict: any): number {
        return placePredict[b.id]?.turnover - placePredict[a.id]?.turnover;
    }
}

export class SortFactory {
    static keys = {
        '': SortBase,
        'price': SortByPrice,
        'height': SortByKey,
        'shelf': SortByShelf
    }

    static getSort(key: SortKey = '', dir: SortDir = '', type: SortType = ''): SortBase {
        return new SortFactory.keys[key.toString()](key, dir, type);
    }
}